var isAbsent=function isAbsent(value){return value==null;};export default isAbsent;